<div class="department-page">
  <div class="department-header">
    <app-header-style-seven></app-header-style-seven>
  </div>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Building future-ready civil engineers through strong academic foundations,
            laboratory exposure, industry relevance, and student-centered development.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Affiliation</span>
            <strong>Anna University</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Civil Engineering, Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title8.jpg"
                  alt="Department of Civil Engineering"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>Broad career and professional outcomes expected from the programme.</p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>Knowledge, skills, and professional capabilities expected from graduates.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>Department-specific competencies developed through the programme.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Labs -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>Practice-oriented labs supporting foundational and advanced civil engineering learning.</p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let lab of labs">
                  <div class="lab-media">
                    <img [src]="lab.image" [alt]="lab.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ lab.title }}</h4>
                    <p>{{ lab.description }}</p>

                    <div class="equipment-note" *ngIf="lab.equipment">
                      <strong>Equipment:</strong> {{ lab.equipment }}
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Association & Club Activities -->
       <!-- Association & Club Activities -->
<!-- Association & Club Activities -->
<ng-container *ngSwitchCase="'tab6'">
  <section class="content-card">
    <div class="section-head">
      <h3>Club &amp; Associations</h3>
      <p>
        Department of Civil Engineering student club activities for the academic year
        {{ clubAcademicYear }}.
      </p>
    </div>

    <div class="fact-grid">
      <article class="fact-card">
        <span class="fact-title">Department</span>
        <p>{{ departmentName }}</p>
      </article>

      <article class="fact-card">
        <span class="fact-title">Academic Year</span>
        <p>{{ clubAcademicYear }}</p>
      </article>

      <article class="fact-card">
        <span class="fact-title">Clubs</span>
        <p>{{ clubNames.join(' & ') }}</p>
      </article>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Events Organized</h3>
      <p>Club-wise activities conducted under the department.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S. No.</th>
            <th>Name of the Club</th>
            <th>Name of the Event</th>
            <th>Resource Person</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of clubEvents">
            <td>{{ event.sno }}</td>
            <td>{{ event.clubName }}</td>
            <td>{{ event.eventName }}</td>
            <td>
              <div *ngFor="let person of event.resourcePersons">
                {{ person }}
              </div>
            </td>
            <td>{{ event.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section-head mt-4">
      <h3>Activity Photos</h3>
      
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of clubActivityPhotos">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ clubActivityHighlight }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>
          <!-- MoUs -->
 <!-- MoUs -->
<ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU Details</h3>
      <p>
        Department of Civil Engineering industry collaboration details through Memoranda of Understanding.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Industry</th>
            <th>MoU Signed Date</th>
            <th>Scope of MoU</th>
            <th>Outcomes of MoU</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mou of mouDetails">
            <td>{{ mou.sno }}</td>
            <td>{{ mou.industryName }}</td>
            <td>{{ mou.signedDate }}</td>
            <td>{{ mou.scope }}</td>
            <td>
              <div *ngFor="let outcome of mou.outcomes">
                {{ outcome }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>MoU Photos</h3>
      <p>{{ mouPhotoNote }}</p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of mouPhotos">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Placement Record -->
     <!-- Placement Record -->
<ng-container *ngSwitchCase="'tab8'">
  <section class="content-card">
    <div class="section-head">
      <h3>Placement Record</h3>
      <p>
        Year-wise placement details of students from the Department of Civil Engineering.
      </p>
    </div>

    <div class="stack-section" *ngFor="let yearGroup of placementRecords">
      <div class="section-head">
        <h3>Academic Year: {{ yearGroup.academicYear }}</h3>
        <p>Student placement details for the academic year {{ yearGroup.academicYear }}.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name of the Student</th>
              <th>Designation</th>
              <th>Name of the Company</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let student of yearGroup.records">
              <td>{{ student.sno }}</td>
              <td>{{ student.studentName }}</td>
              <td>{{ student.designation }}</td>
              <td>{{ student.companyName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</ng-container>

          <!-- Industrial Visit -->
       <!-- Industrial Visit -->
<ng-container *ngSwitchCase="'tab9'">
  <section class="content-card">
    <div class="section-head">
      <h3>Industrial Visit</h3>
      <p>
        Industrial visit highlights of the Department of Civil Engineering.
      </p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of industrialVisitPhotos; let i = index">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ industrialVisitNotes[i] }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Value Added Courses -->
<!-- Value Added Courses -->
<ng-container *ngSwitchCase="'tab10'">
  <section class="content-card">
    <div class="section-head">
      <h3>Value Added Courses</h3>
      <p>
        Additional skill-oriented courses conducted for the students of the
        Department of Civil Engineering.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Course Name</th>
            <th>Duration</th>
            <th>Company Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let course of valueAddedCourses">
            <td>{{ course.sno }}</td>
            <td>{{ course.courseName }}</td>
            <td>{{ course.duration }}</td>
            <td>{{ course.companyName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Alumni -->
       <!-- Alumni -->
<ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Alumni</h3>
      <p>
        Distinguished alumni of the Department of Civil Engineering.
      </p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let alumni of alumniRecords">
        <div class="lab-media">
          <img [src]="alumni.image" [alt]="alumni.alt" />
        </div>

        <div class="lab-body">
          <h4>{{ alumni.name }}</h4>
          <p><strong>Batch:</strong> {{ alumni.batch }}</p>
          <p><strong>Designation:</strong> {{ alumni.designation }}</p>
          <p><strong>Organization:</strong> {{ alumni.organization }}</p>
          <p *ngIf="alumni.location">
            <strong>Location / Sector:</strong> {{ alumni.location }}
          </p>
        </div>
      </article>
    </div>
  </section>
</ng-container> 

          <!-- Achievements -->
     <!-- Achievements -->
<ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>
        Student achievements of the Department of Civil Engineering in various
        academic, cultural, and technical events.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S. No.</th>
            <th>Name of the Student</th>
            <th>Name of the Event</th>
            <th>Name of the College with Address</th>
            <th>State / National / International Level</th>
            <th>Date of Event</th>
            <th>Name of the Award</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of achievements">
            <td>{{ item.sno }}</td>
            <td>
              <div *ngFor="let student of item.studentNames">
                {{ student }}
              </div>
            </td>
            <td>{{ item.eventName }}</td>
            <td>{{ item.collegeName }}</td>
            <td>{{ item.level }}</td>
            <td>{{ item.eventDate }}</td>
            <td>{{ item.awardName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Achievement Photos</h3>
      <p>Highlights from prize-winning student activities and competitions.</p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let photo of achievementPhotos; let i = index">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ achievementPhotoNotes[i] }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- NPTEL -->
    <!-- NPTEL -->
<ng-container *ngSwitchCase="'tab13'">
  <section class="content-card">
    <div class="section-head">
      <h3>NPTEL</h3>
      <p>
        NPTEL course certifications completed by faculty members of the
        Department of Civil Engineering.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Staff</th>
            <th>Subject</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of nptelRecords; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.staffName }}</td>
            <td>{{ item.subject }}</td>
            <td>{{ item.grade }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Research -->
    <!-- Research -->
<ng-container *ngSwitchCase="'tab15'">
  <section class="content-card">
    <div class="section-head">
      <h3>Conference</h3>
      <p>
        Conference publications and paper presentations by faculty members of the
        Department of Civil Engineering.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Conference</th>
            <th>Title of the Paper</th>
            <th>Name of the Author</th>
            <th>College Name</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of conferenceRecords">
            <td>{{ item.sno }}</td>
            <td>{{ item.conferenceName }}</td>
            <td>{{ item.paperTitle }}</td>
            <td>
              <div *ngFor="let author of item.authors">
                {{ author }}
              </div>
            </td>
            <td>{{ item.collegeName }}</td>
            <td>{{ item.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Patent</h3>
      <p>
        Patent and design publications recorded under the Department of Civil Engineering.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Academic Year</th>
            <th>Name</th>
            <th>Categories</th>
            <th>Title of the Invention</th>
            <th>Application Number</th>
            <th>Date of Publication</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of patentRecords">
            <td>{{ item.sno }}</td>
            <td>{{ item.academicYear }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.inventionTitle }}</td>
            <td>{{ item.applicationNumber }}</td>
            <td>{{ item.publicationDate }}</td>
            <td>{{ item.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <br>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Civil Engineering,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:civilhod@fmcet.ac.in">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Civil Engineering</h3>
        <p>Become a civil engineer and build sustainable infrastructure for the future.</p>
 <a
  routerLink="/inquiry"
  class="apply-button"
>
  Apply Now
</a>
      </article>
    </section>
  </div>
</div>